import { render, staticRenderFns } from "./orderModule.vue?vue&type=template&id=6444a37e"
import script from "./orderModule.vue?vue&type=script&lang=js"
export * from "./orderModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports